import { isUnsupportedPublishPlatform } from './unsupported-publish';

export function failedPublishablePlatforms(
  platforms: readonly string[],
  isFailed: (platform: string) => boolean,
): string[] {
  return platforms.filter(
    (platform) => isFailed(platform) && !isUnsupportedPublishPlatform(platform),
  );
}

export function pickDefaultPlatform(input: {
  platforms: readonly string[];
  connected: readonly string[];
  failed: readonly string[];
}): string | null {
  const { connected, failed } = input;
  const publishable = input.platforms.filter((platform) => !isUnsupportedPublishPlatform(platform));
  const platforms = publishable.length > 0 ? publishable : input.platforms;
  const failedFirst = platforms.find((platform) => failed.includes(platform));
  if (failedFirst) return failedFirst;
  return platforms.find((platform) => connected.includes(platform)) ?? platforms[0] ?? null;
}
